import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useGeoState, useGeoFetch } from "../../../components/GeoProvider";
import ErrorMessage from "../../../components/Layout/ErrorMessage";
import DisplayDateFluNew from "../../../components/DisplayDateFlu/DisplayDateFluNew";
import Spinner from "../../../components/Loader/Spinner";
import EmptyMap from "../../../components/Map/emptyMap";
import Timeline from "../../../components/Timeline";
import Map from "../../../components/Map";
import toolTipFormatter from "../toolTipFormatter";
import MapLegend from "../cdcMapLegendHorizontal";
import SideTable from "./SideTable";
import styles from "./MapPage.module.scss";
import dayjs from "dayjs";
import ErrorLogs from "../../../components/ErrorBoundary/errorlogs";
import { useAuthState } from "../../../components/AuthProvider";
import AqiIndexGrid from "../Charts/AqiIndexGrid";
const DashboardMap = ({ geo_type, geo_parent, zoomLocation }) => {
  const { user } = useAuthState();
  const chartRef = useRef(null);
  // const entity = 'flu'
  const slotTimeInSeconds = 604800000;
  const latestPositionString = "";
  const slotString = "week";
  const location = useLocation();
  const hash = location.hash;
  const [getMapStates, setMapStates] = useState();
  const [errorCode, setErrorCode] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [errorSubject, setErrorSubject] = useState();
  const [errorOccured, seterrorOccured] = useState(false);
  const [getCBSAJsonData, setCBSAJsonData] = useState();
  const [getStateJson, setStateJson] = useState();
  const [getMapZip3, setMapZip3] = useState();
  const [activeZip3, setactiveZip3] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
    diseaseSelected,
    setDisplayDate,
    setDiseaseSelected,
  } = useGeoState();
  setDiseaseSelected(window.localStorage.getItem("disease"));
  if (hash) {
    if (hash.split("-").length > 1) {
      setRegionSelected(hash.split("-")[0].replace("#", ""));
    }
  }
  const { data: statesData, error: MapError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    "allergiesMap",
    `STATE/${diseaseSelected}`,
    "",
    {
      geo_parent: "US",
    }
  );

  useEffect(() => {
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        var datacount = Object.keys(statesData.response_data).length - 1;
        setDisplayDate(Object.keys(statesData.response_data)[datacount]);
        setMapStates(statesData.response_data);
      } else {
        setMapStates(null);
        setErrorCode(statesData.response_code);
        setErrorMessage(statesData.response_message);
        setErrorSubject(statesData.response_subject);
        seterrorOccured(true);
      }
    }
  }, [statesData]);

  const { data: zip3Datanew, error: MapZip3Error } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    "allergiesMap",
    `ZIP3/${diseaseSelected}`,
    '',
    {
      'geo_parent' : geo_parent
    }
  );

  useEffect(() => {
    setIsLoading(true);
    if (zip3Datanew !== null && zip3Datanew !== undefined) {
      if (zip3Datanew.response_code === 200) {
        ErrorLogs({
          message_type: "Activity",
          error_details: "Dashboard access success",
          user: user,
        });
        setMapZip3(zip3Datanew.response_data);
      } else if (zip3Datanew.response_code === 404) {
        setMapZip3(zip3Datanew.response_data);
        ErrorLogs({
          message_type: "Error",
          error_details: `${zip3Datanew.response_subject}, ${zip3Datanew.response_message},for ${geo_parent}`,
          user: user,
        });
      } else {
        setMapZip3(null);
        setErrorCode(zip3Datanew.response_code);
        setErrorMessage(zip3Datanew.response_message);
        setErrorSubject(zip3Datanew.response_subject);
        seterrorOccured(true);
      }
      setIsLoading(false);
    }
  }, [zip3Datanew]);

  const { data: activeZIP3Data, error: activeZIP3DataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'activeLocations',
    '',
    '',
    { 
      'geo_type' : 'ZIP3', 
      'geo_parent_code' : geo_parent 
    }
  );

  useEffect(() => {
    if (activeZIP3Data !== null && activeZIP3Data !== undefined) {
      setactiveZip3(activeZIP3Data);
    }
  }, [activeZIP3Data]);

  useEffect(() => {
    let url = `${window.location.origin}/allergies/usStatesAll.json`;
    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        setStateJson(data);
      })
      .catch(function (err) {
        console.log(err, " error file usStatesAll.json");
      });
  }, [1]);

  const [getzip3Json, setzip3Json] = useState();
  useEffect(() => {
    let url = `${window.location.origin}/allergies/three_dig_zips.json`;
    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        setzip3Json(data);
      })
      .catch(function (err) {
        console.log(err, " error file load us_hrr_values ");
      });
  }, [1]);
  if (MapError || errorOccured || activeZIP3DataError || MapZip3Error) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorCode === 404 ? `for ${geo_parent}` : errorMessage}
      />
    );
  }

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.timelinePanel}`}>
        {regionSelected === "state" && (
          <>
            {zip3Datanew !== undefined &&
            getMapStates !== undefined &&
            activeZip3 !== undefined &&
            getzip3Json !== undefined &&
            !isLoading ? (
              <>
                <div className={`${styles.providerHeader}`}>
                  <Timeline
                    statesData={getMapStates}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    markCounts={7}
                    loadError={MapError}
                    dashboardType={"ALLERGIES"}
                  />
                </div>
              </>
            ) : (
              <Spinner />
            )}
          </>
        )}
      </div>
      <div className={`${styles.cbsasPanel}`}>
        <>
          <SideTable
            geo_id={geo_parent}
            geo_type={geo_type}
            disease_id={diseaseSelected}
          />
        </>
      </div>

      <div className={`${styles.map}`}>
        {regionSelected === "state" && (
          <>
            {getMapZip3 !== undefined &&
            getMapStates !== undefined &&
            activeZip3 !== undefined &&
            getzip3Json !== undefined &&
            !isLoading ? (
              <>
                <div className={styles.legendDiv}>
                  <MapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={null}
                  activeZip3Data={activeZip3}
                  statesData={getMapStates}
                  cbsaData={null}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="ZIP3MAP"
                  enableButtons={true}
                  zoomLocation={zoomLocation}
                  chartRef={chartRef}
                  mapDataType={geo_type === "STATE" ? 0 : 1}
                  stateJson={getStateJson}
                  dashboardType="ALLERGIES"
                  zip3Json={getzip3Json}
                  zip3Data={getMapZip3}
                />
              </>
            ) : (
              <EmptyMap />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DashboardMap;
